export default {"src":"/_next/static/media/icon_location-pin.211fcde1.svg","height":20,"width":15,"blurWidth":0,"blurHeight":0};